import { TextField as MuiTextField } from "@material-ui/core";
import { TextFieldProps as MuiTextFieldProps } from "@material-ui/core/TextField";
import { FieldInputProps, useField } from "formik";
import { CountryCode } from "libphonenumber-js/min";
import * as React from "react";

import { PhoneInput } from "../inputs";

interface OwnProps {
    id: string;
    countryCode?: CountryCode;
    validate?: (value: any) => string | Promise<void> | undefined;
}

type TextFieldProps = Exclude<MuiTextFieldProps, { variant }> &
    Partial<FieldInputProps<any>> &
    OwnProps;

export const PhoneField = (props: TextFieldProps) => {
    const {
        countryCode,
        name = props.id,
        checked,
        onBlur,
        onChange,
        multiple,
        validate,
        ...muiProps
    } = props;
    const [field, meta] = useField({
        name,
        checked,
        onBlur,
        onChange,
        multiple,
        validate,
    });

    const handleChange = React.useCallback(
        (e: React.ChangeEvent<any>) => {
            field.onChange(e);
            if (onChange) onChange(e);
        },
        [field, onChange]
    );

    const showError = !!meta.error;
    const errMsg = showError ? meta.error : undefined;
    const { InputProps } = muiProps;

    return (
        <MuiTextField
            {...muiProps}
            InputProps={{
                ...InputProps,
                ...field,
                onChange: handleChange,
                inputComponent: PhoneInput as any,
            }}
            error={showError}
            helperText={errMsg}
        />
    );
};
